import KMaskedTextField from "./KMaskedTextField";

export default KMaskedTextField.extend( {
	name: "KPhoneField",

	props: {
		maskOptions: {
			...KMaskedTextField.options.props.maskOptions,
			default: () => ( { mask: "(000) 000-0000" } ),
			required: false
		},

		maxLength: {
			...KMaskedTextField.options.props.maxLength,
			default: 14
		},

		prependIcon: {
			...KMaskedTextField.options.props.prependIcon,
			default: "phone"
		},

		type: {
			...KMaskedTextField.options.props.type,
			default: "tel"
		}
	}
} );
